import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	// public root_url:string = 'http://164.52.202.9:1337/amsuser/';
	public root_url:string = 'https://api.pareekshn.com/amsuser/';
	//public root_url: string = 'http://localhost:1337/amsuser/';

	/* Student id */
	public studentId = 0;

	/* Authenticate url */
	public complSteps = {};
	publisherObj: OT.Publisher;
	public getRandUrl(route) {
		var date = new Date();
		var timestamp = date.getTime();
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ-abcdefghijklmnopqrstuvwxyz-0123456789-" + timestamp;
		for (var i = 0; i < 70; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		this.complSteps[route] = text;
		return text;
	}
}